const BaseModule = require('../../90_utils/base/BaseModule');

class ReadMoreGoop extends BaseModule {

	constructor(el, params) {
		super(el);

		this.gradientTopColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.gradientBottomColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

		this.$shape;
		this.$gradient;
		this.$gradientStops;
		this.$goopPath;
		this.$line;

		// init shapes

		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');
		this.$goopPath = this.$shape.find('#bulge-path');
		this.$line = this.$el.find('.line');

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');
	}

	// basemodule methods

	_domReady(){}

	_addListeners(){

	}

	_removeListeners(){

	}

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let scale = window.SETTINGS.breakpoint.minWidth('screen-small') ? 1 : 1.5769230769;
		let containerWidth = this.$el.outerWidth() * 2 * scale; // scaled down by half, need to double assumed container (dumb)
		let bulgeWidth = 538;
		let bleed = (containerWidth - bulgeWidth)/2;

		let newD = 'M427.5,77.4C280.5,74.4,326,0,269,0s-11.6,74.4-158.5,77.4C109.1,77.4,2.3,78,2.3,78L' + (0 - bleed) + ',78v4 h' + containerWidth + 'v-4l-1.5,0C536.5,78,428.9,77.4,427.5,77.4z';

		this.$gradientStops.eq(0).attr('stop-color', this.gradientTopColor);
		this.$gradientStops.eq(1).attr('stop-color', this.gradientBottomColor);
		this.$goopPath.attr('d', newD);
		this.$line.css('background', this.gradientBottomColor);
	}
}

module.exports = ReadMoreGoop;
